HIPSTER_COLORS = [
  '#54e26f'
  '#f1c40f'
  '#e67e22'
  '#db2442'
  '#c17fe7'
  '#3498db'
  '#16a085'
  '#34495e'
]

POLYGON_OPACITY_DEFAULT  = 0.4
POLYGON_OPACITY_SELECTED = 0.8

POLYGON_STROKE_DEFAULT  = 1
POLYGON_STROKE_SELECTED = 2


computedPolygons = (dependentKey) ->
  options =
    addedItem: (array, model, changeMeta, instanceMeta) ->
      map = @get('map')
      return unless ymaps and map

      area = []
      if model.get('area') and model.get('area').length > 0
        area = [ model.get('area') ]

      polygon = new ymaps.Polygon(area)

      polygon.options.set
        opacity:   POLYGON_OPACITY_DEFAULT
        fillColor: HIPSTER_COLORS[changeMeta.index % HIPSTER_COLORS.length]

      polygon.events.add 'click', (event) =>
        unless @get('isEditing')
          @sendAction('onZoneSelected', model)

      @get('map').geoObjects.add(polygon)

      array.insertAt(changeMeta.index, {
        polygon: polygon
        model: model
      })
      array

    removedItem: (array, item, changeMeta, instanceMeta) ->
      map = @get('map')
      return unless ymaps and map

      arrayItem = array.findBy('model', item)
      return unless arrayItem

      polygon = arrayItem.polygon
      @get('map').geoObjects.remove(polygon)

      array.removeAt(changeMeta.index, 1)
      array

  Ember.arrayComputed(dependentKey, options)

###
# Внешние биндиндги:
#   selectedZone - выбранная зона на карте
###
App.SmDeliveryMapComponent = Em.Component.extend
  ###
  # Поля
  ###
  classNames: [ 'delivery-map-component' ]
  map: null
  restaurantMarker: null
  zonesPolygonsPairs: computedPolygons('zones', 'map')

  ###
  # Проброшенные свойства
  ###
  isEditing: false

  ###
  # Свойства
  ###
  selectedPolygon:( ->
    zone = @get('selectedZone')
    @get('zonesPolygonsPairs')?.findBy('model', zone)?.polygon
  ).property('selectedZone', 'zonesPolygonsPairs.[]')

  initializeProps: (->
    @set('obtainDefers', Em.A([]))
  ).on('init')

  yandexMapsService: Em.inject.service('yandexMaps')

  ###
  # Методы
  ###
  didInsertElement: ->
    @get('yandexMapsService').retrieve()
    .then (ymaps) =>
      ymaps.ready(@initializeMap.bind(@))

  initializeMap: ->
    map = new ymaps.Map 'delivery-map',
      center: [55.76, 37.64]
      zoom: 7
      controls: ['zoomControl']

    map.controls.add('searchControl', float: 'left')
    map.behaviors.disable('dblClickZoom')
    map.behaviors.disable('scrollZoom')

    # Инициализируем все поля
    @set('map', map)
    map.events.add 'click', @onMapClick, @

    @get('zonesPolygonsPairs')

    @focusPolygons( @get('zonesPolygonsPairs').map (pair) -> pair.polygon )

    @set('initialized', true)
    @trigger('mapInitialized')
    @get('obtainDefers').forEach (defer) =>
      defer.resolve(map)

  onMapClick: ->
    unless @get('isEditing')
      @sendAction('onZoneSelected', null)

  # ---
  # Запрашивает экземпляр карты. Гарантирует, что карта инициализирована
  # ---
  obtainMap: ->
    defer = Em.RSVP.defer()

    if @get('initialized')
      defer.resolve(@get('map'))
    else
      @get('obtainDefers').pushObject(defer)

    defer.promise

  # ---
  # Центрирует карту на заданных полигонах
  # ---
  focusPolygons: (polygons) ->
    return unless polygons.length > 0
    map = @get('map')

    polyCollection = new ymaps.GeoObjectCollection()
    polygons.forEach (p) =>
      if p?.geometry?.getLength()
        polygon = new ymaps.Polygon(p.geometry.getCoordinates(), {}, {opacity: 0})
        polyCollection.add(polygon)

    if polyCollection.getLength() > 0
      map.geoObjects.add(polyCollection)

      map.setBounds(polyCollection.getBounds(),
        duration: 200, margin: 80)

      map.geoObjects.remove(polyCollection)

  highlightPolygons: (polygons) ->
    @get('zonesPolygonsPairs').forEach (pair) ->
      return unless pair?.polygon?

      if polygons.indexOf(pair.polygon) is -1
        pair.polygon.options.set
          opacity:     POLYGON_OPACITY_DEFAULT
          strokeWidth: POLYGON_STROKE_DEFAULT
      else
        pair.polygon.options.set
          opacity:     POLYGON_OPACITY_SELECTED
          strokeWidth: POLYGON_STROKE_SELECTED


  ###
  # Наблюдатели
  ###
  onSelectedRestaurantChanged: (->
    restaurant = @get('selectedRestaurant')
    return unless restaurant

    @obtainMap().then (map) =>
      selectedZone    = @get('selectedZone')
      selectedPolygon = @get('selectedPolygon')

      if selectedZone and selectedPolygon and (selectedPolygon?.geometry?.getLength() > 0)
        @focusPolygons([ selectedPolygon ])
        @highlightPolygons([ selectedPolygon ])
        return

      if !selectedZone
        @highlightPolygons([])

      polygons = @get('zonesPolygonsPairs')?.filter (pair) =>
        pair.model.get('restaurant.id') is restaurant.get('id')
      .map (pair) =>
        pair.polygon
      .filter (polygon) =>
        polygon?.geometry?.getLength() > 0

      @focusPolygons(polygons)
  ).observes('selectedRestaurant', 'selectedZone')
    .on('didInsertElement')

  onIsEditingChanged: (->
    return unless @get('initialized')

    polygon = @get('selectedPolygon')
    return unless polygon

    if @get('isEditing')
      if polygon.geometry.getLength() > 0
        polygon.editor.startEditing()
      else
        polygon.editor.startDrawing()
    else
      polygon.editor.stopDrawing()
      polygon.editor.stopEditing()
  ).observes('isEditing', 'initialized')

  restaurantMarkerObserver: Ember.observer('selectedRestaurant.latitude', 'selectedRestaurant.longitude', ->
    @obtainMap().then (map) =>
      selectedRestaurant = @get('selectedRestaurant')
      restaurantMarker =  @get('restaurantMarker')

      if !selectedRestaurant or !selectedRestaurant.get('hasCoordinates')
        if restaurantMarker?
          map.geoObjects.remove(restaurantMarker)
          @set 'restaurantMarker', null
        return

      if restaurantMarker
        restaurantMarker.geometry.setCoordinates([selectedRestaurant.get('latitude'), selectedRestaurant.get('longitude')])
      else
        restaurantMarker = new ymaps.Placemark([selectedRestaurant.get('latitude'), selectedRestaurant.get('longitude')], {},{
          iconLayout: 'default#image',
          iconImageHref: "images/map-markers/restaurant-marker-round.png",
          iconImageSize: [28, 28],
          iconImageOffset: [-13, -13]
        })

        map.geoObjects.add(restaurantMarker)
        @set 'restaurantMarker', restaurantMarker
  ).on('mapInitialized')

  ###
  # События
  ###
  actions:
    finishEditing: ->
      @set('isEditing', false)
      zone    = @get('selectedZone')
      polygon = @get('selectedPolygon')
      coords = polygon?.geometry?.getCoordinates()[0]
      zone.set('area', coords) if coords

      @sendAction('onZoneAreaChanged', @get('selectedZone'))

    cancelEditing: ->
      zone = @get('selectedZone')

      if zone.get('isNew')
         @sendAction('onZoneCancelCreate', null)
      else
        @get('selectedPolygon')?.geometry?.setCoordinates([zone.get('area')])

      @set('isEditing', false)

